module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_3016.afff03f0.png";